import React, { Component } from "react";
import InputForm from "../../html/inputForm";
import commonContext from "../../../context/common";

interface IProps {}
interface IState {}
export class ParsonalBankUseOnly extends Component<IProps, IState> {
    static contextType = commonContext;
    handleOnChange = (e: any) => {
        const { setLead } = this.context;
        let state = {};
        state[e.target.name] = e.target.value;
        setLead(state);
    };
    render() {
        const { lead } = this.context;
        return (
            <>
                <div className="relative mb-3 w-1/2 lg:w-1/3 px-5">
                    <InputForm
                        label="Branch Code"
                        errorText="Please enter Branch Code"
                        name="branchCode"
                        handlerOnChange={(e) => this.handleOnChange(e)}
                        value={lead.branchCode}
                    />
                </div>
                <div className="relative mb-3 w-1/2 lg:w-1/3 px-5">
                    <InputForm
                        label="LG Code"
                        errorText="Please enter LG Code"
                        name="lgCode"
                        handlerOnChange={(e) => this.handleOnChange(e)}
                        value={lead.lgCode}
                    />
                </div>
                <div className="relative mb-3 w-1/2 lg:w-1/3 px-5">
                    <InputForm
                        label="SM Code"
                        errorText="Please eneter SM Code"
                        name="smCode"
                        handlerOnChange={(e) => this.handleOnChange(e)}
                        value={lead.smCode}
                    />
                </div>
                <div className="relative mb-3 w-1/2 lg:w-1/3 px-5">
                    <InputForm
                        label="DSA Code"
                        errorText="Please eneter DSA Code"
                        name="dsaCode"
                        handlerOnChange={(e) => this.handleOnChange(e)}
                        value={lead.dsaCode}
                    />
                </div>
                <div className="relative mb-3 w-1/2 lg:w-1/3 px-5">
                    <InputForm
                        label="SE Code"
                        errorText="Please eneter SE Code"
                        name="seCode"
                        handlerOnChange={(e) => this.handleOnChange(e)}
                        value={lead.seCode}
                    />
                </div>
                <div className="relative mb-3 w-1/2 lg:w-1/3 px-5">
                    <InputForm
                        label="TSE Code"
                        errorText="Please eneter TSE Code"
                        name="tseCode"
                        handlerOnChange={(e) => this.handleOnChange(e)}
                        value={lead.tseCode}
                    />
                </div>
            </>
        );
    }
}

export default ParsonalBankUseOnly;
